// @flow
import React from "react";
import { Field } from "redux-form";
import classnames from "classnames";
import { Form } from "semantic-ui-react";
import { useTranslation } from "react-i18next";

import FormLabel from "Commons/Components/FormComponents/components/FormLabelWithDivider";
import { InputField } from "../../ChangeServices/submodules/Old_Edit/components/Fields";
import { isPhoneNumberValidForCsEdit } from "../../../../Commons/Utilities/validators";
import Styles from "../../ChangeServices/submodules/Old_Edit/components/Customer/SharedStyles.module.scss";

type Props = {
  mobileChangeService?: boolean,
  noLabel?: boolean,
  widthAreaCode?: number,
  widthCellPhoneNumber?: number,
};
export const PhoneNumber = ({ noLabel, widthAreaCode = 5, widthCellPhoneNumber = 5, mobileChangeService }: Props) => {
  const { t } = useTranslation("changeService");
  return (
    <Form.Group data-cy="areaCodeAndPhoneNumber" id={Styles["inline"]}>
      {!noLabel && (
        <FormLabel
          title={t("wizard.customer.areaCodeAndPhoneNumber.label")}
          inline
          tooltip={t("wizard.customer.areaCodeAndPhoneNumber.tooltip")}
          secondary
        />
      )}
      <div className={Styles.phoneNumberBlock}>
        <span className={Styles.areaCode}>+49</span>
        <Field
          name="formattedE164PhoneNumber"
          component={InputField}
          validate={isPhoneNumberValidForCsEdit}
          props={{
            id: "cellPhoneNumber",
            placeholder: t("wizard.customer.phoneNumber"),
            width: widthCellPhoneNumber,
            showErrorMessage: false,
            className: classnames({
              [Styles.full]: mobileChangeService,
            }),
          }}
        />
      </div>
    </Form.Group>
  );
};
